import { Link } from 'react-router-dom';
import { FileText, Users, Camera } from 'lucide-react';

const cards = [
  { to: '/admin/announcement', label: 'Redigera meddelande', icon: FileText },
  { to: '/admin/allowlist', label: 'Hantera allowlist', icon: Users },
  { to: '/admin/album', label: 'Hantera album', icon: Camera },
];

export default function AdminHome() {
  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-3xl font-serif text-primary mb-6">Admin</h1>
      <div className="grid gap-4 md:grid-cols-3">
        {cards.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md flex flex-col items-center text-center gap-3"
          >
            <c.icon className="text-primary" size={32} />
            <span className="font-medium">{c.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
